import React from 'react';
import {PiSmiley, PiSmileyMeh} from "react-icons/pi";

export function FeedbackItem({text, type, date, isNew}) {


    return (
        <div className={" "} style={{fontFamily:"Poppins"}}>
            <div className={"row mb-2"}>
                <div className={"col"}>
                    {
                        type === "STRENGTH" ?
                            <div className={"badge bg-success text-white me-3 d-flex align-items-center p-2"}
                                 style={{width: "fit-content"}}>
                                <PiSmiley size={24} className={"me-2"}/>
                                <label className={"fs-6"}>
                                    Positiv tilbakemelding
                                </label>
                            </div>
                            :
                            <div className={"badge bg-danger text-white me-3 d-flex align-items-center p-2"}
                                 style={{width: "fit-content"}}>
                                <PiSmileyMeh size={24} className={"me-2"}/>
                                <label className={"fs-6"}>
                                    Forbedringspotensiale
                                </label>
                            </div>
                    }
                </div>
                <div className={"col-2 d-flex align-items-center"}>
                    <p className={"m-0 p-0 text-muted"}>{date}</p>
                    {
                        isNew ? <span className={"badge bg-warning text-white ms-2 p-2 rounded-5 "}>Ny</span> : null
                    }

                </div>

            </div>

            <p className={"m-0 p-0 mb-2 w-75"}>{text}</p>

        </div>
    );

}